import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VBtn,_vm._g({attrs:{"icon":""}},on),[_c(VIcon,{attrs:{"color":"grey lighten-1"}},[_vm._v(_vm._s(_vm.toopltipIcon))])],1)]}}]),model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c(VImg,{attrs:{"src":_vm.tooltipImage,"lazy-src":_vm.tooltipImage,"max-height":"600px","max-width":"600px","contain":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }